const normalizeUrl = (url: string): string => {
  if (!url) return "";

  const str = url.trim();

  // if has protocol (any) return as is
  if (/^[a-zA-Z][a-zA-Z\d+\-.]*:/.test(str)) {
    return str;
  }

  // if value like www.abc.com or abc.com add https, but not for abc@gmail.com or any mail address
  if (/^(?!.*@)(www\.)?[\w.-]+\.[a-zA-Z]{2,}/.test(str)) {
    return "https://" + str;
  }

  return str;
};

export default normalizeUrl;
